import React from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { makeStyles } from 'design-system/styles';
import { Modal } from 'design-system/Modal';
import { getAnnotationId } from '@scale/frontend-lib/annotation';
import LinkedAnnotationSelectorItem from './LinkedAnnotationSelectorItem';
import { Annotation, AnnotationAttribute, LinkedAttribute } from '@scale/shared/types/annotation';

const LinkedAnnotationSelector = (props: {
  annotationId: string;
  annotations: Annotation[];
  getColorForAnnotation: (annotation: Annotation) => string;
  attributeDefinition: { name: string; definition: AnnotationAttribute };
  selectedId?: string;
  handleClose: () => void;
  handleSelectLabel: (id?: string) => void;
}) => {
  const {
    annotationId,
    annotations,
    getColorForAnnotation,
    attributeDefinition,
    selectedId,
    handleClose,
    handleSelectLabel,
  } = props;

  const classes = makeStyles(theme => ({
    wrapper: {
      fontSize: '14px',
    },
    description: {
      padding: '16px',
      borderBottom: `1px solid ${theme.colors.gray10}`,
    },
    body: {
      padding: '16px',
    },
    strong: {
      fontWeight: 500,
    },
    reset: {
      padding: '4px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover': {
        background: theme.colors.gray01,
      },
    },
    resetIcon: {
      width: '16px',
      marginRight: '8px',
      opacity: 0.5,
      textAlign: 'center',
    },
  }))();

  const allowedLabels = (attributeDefinition.definition as LinkedAttribute).allowed_labels;

  return (
    <Modal isOpen={true} onRequestClose={handleClose}>
      <div className={classes.wrapper}>
        <div className={classes.description}>
          Select an annotation for{' '}
          <span className={classes.strong}>{attributeDefinition.definition.description}</span>
        </div>

        <div className={classes.body}>
          <div className={classes.reset} onClick={() => handleSelectLabel(undefined)}>
            <div className={classes.resetIcon}>
              <FontAwesomeIcon icon="times" />
            </div>{' '}
            Clear
          </div>

          {annotations.map(annotation => {
            const id = getAnnotationId(annotation);
            if (id === annotationId) {
              return null;
            }
            if (allowedLabels && !_.includes(allowedLabels, annotation.label)) {
              return null;
            }

            const color = getColorForAnnotation(annotation);
            const handleSelect = () => handleSelectLabel(id);

            return (
              <LinkedAnnotationSelectorItem
                key={id}
                id={id}
                label={annotation.label || 'Annotation'}
                color={color}
                isSelected={selectedId === id}
                handleSelect={handleSelect}
              />
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default LinkedAnnotationSelector;
